import AppButton from "@/components/AppButton.vue";
import HeaderFluxo from "@/components/HeaderFluxo.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import TextLink from "@/components/TextLink.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import { Component, Vue } from "vue-property-decorator";
import Slick from "vue-slick";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 5,
  newestOnTop: true,
});

@Component({
  components: { HeaderFluxo, Slick, AppButton, TextLink, ModalCodigo },
})
export default class Survey extends Vue {
  survey: any = [];
  surveyId: any = sessionStorage.getItem("CURRENT_SURVEY");
  surveyTitle: any = sessionStorage.getItem("TITLE_SURVEY") || "";
  currentQuestion: any = 0;
  currentQuestionId: any = 0;
  currentQuestionIndex: any = 0;
  currentAnswers: any = [];
  questionLabel = "";
  currentType = "";
  comentAnswer = "";
  userAnswers: any = {};
  currentUserAnswer: any = [];
  checkedRadio: any = -1;
  checkedRating: any = -1;
  checkedBoxes: any = [];
  textAreaValue: any = "";
  noMoreQuestions = false;
  getOutSurvey = false;
  msgGetOut = "";
  checkedIndex: any = -1;
  disableBack = false;
  disableNext = false;
  disableEnd = false;
  radioGroup: any = null;
  rating: any = null;

  mounted() {
    Util.setBackButtonBehavior(this.goBack);
    //On mounted make the request to get the information of this specific survey by the I
    this.getSurveyInfo();
    setTimeout(function () {
      $("#GO_NEXT > button").prop("disabled", true);
    }, 100);
    //mounting the base of user answers
    if (this.survey != []) {
      this.userAnswers = {
        surveyId: this.surveyId,
        questions: [],
      };
      this.mountQuestion();
    }
  }

  getSurveyInfo() {
    const req = new Request();
    req.body = {
      USER_ID: sessionStorage.getItem("USER_ID"),
      NRORG: sessionStorage.getItem("NRORG"),
      TOKEN: sessionStorage.getItem("TOKEN"),
      SURVEY_ID: sessionStorage.getItem("CURRENT_SURVEY"),
    };
    req.route = "getSurQuestion";
    req.callbackSuccess = (response: any) => {
      if (response) this.survey = response;
      this.mountQuestion();
      if (this.survey != []) {
        this.userAnswers = {
          surveyId: this.surveyId,
          questions: [],
        };
        this.mountQuestion();
      }
    };
    req.callbackError = function (error: any) {
      console.log(error);
    };
    req.blockTouchEvents = false;
    req.send();
  }

  sendSurveyInfo() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        SURVEY_ID: sessionStorage.getItem("CURRENT_SURVEY"),
        SURVEY_ANSWERS: this.userAnswers,
      };
      req.route = "submitAnswers";
      req.callbackSuccess = function () {
        self.$router.replace("Surveys");
        this.$toast.success("Obrigado por responder nossa pesquisa!");
      };
      req.callbackError = function () {
        self.$router.replace("Surveys");
        this.$toast.success("Ocorreu um erro ao finalizar a pesquisa.");
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  validateAnswer() {
    if (
      this.currentQuestion.type == "radio" ||
      this.currentQuestion.type == "rate"
    ) {
      for (let y = 0; y <= this.currentAnswers.length; y++) {
        const anyAnswer = this.currentAnswers.find(
          (el: any) =>
            el.id === this.radioGroup || Number(el.answer) === this.rating
        );
        if (anyAnswer) {
          if (this.currentQuestion.type == "radio") {
            this.currentUserAnswer = this.radioGroup || "";
          } else if (this.currentQuestion.type == "rate") {
            this.currentUserAnswer = anyAnswer.id || "";
          }
          this.disableNext = false;
          this.disableEnd = false;
          break;
        } else {
          this.disableNext = true;
          this.disableEnd = true;
        }
      }
    } else if (this.currentQuestion.type == "checkbox") {
      for (let i = 0; i <= this.checkedBoxes.length; i++) {
        const anyAnswer = this.currentAnswers.find(
          (el: any) => el.id === this.checkedBoxes[i]
        );
        if (anyAnswer) {
          this.currentUserAnswer = this.checkedBoxes || [];
          this.disableNext = false;
          this.disableEnd = false;
          break;
        } else {
          this.disableNext = true;
          this.disableEnd = true;
        }
      }
    } else if (this.currentQuestion.type == "textarea") {
      const anyAnswer = this.currentAnswers.find(
        (el: any) => $("#textArea" + el.id).val() != ""
      );
      if (anyAnswer) {
        this.currentUserAnswer = this.textAreaValue || "";
        this.disableNext = false;
        this.disableEnd = false;
      } else {
        this.disableNext = true;
        this.disableEnd = true;
      }
    }
  }

  validateEmpty() {
    if (this.currentType == "radio")
      if (this.checkedRadio == null || this.checkedRadio == 0) return false;
    if (this.currentType == "rate")
      if (this.checkedRating == null || this.checkedRating == 0) return false;
    if (this.currentType == "checkbox")
      if (this.checkedBoxes == null || this.checkedBoxes == []) return false;
    if (this.currentType == "textarea")
      if (this.textAreaValue == null || this.textAreaValue == "") return false;
    return true;
  }

  getOutSurveyRequest() {
    this.msgGetOut =
      "Ao sair no meio da pesquisa você terá que responder todas as perguntas novamente quando voltar. Deseja realmente sair?";
    this.getOutSurvey = true;
  }

  goNext() {
    if (this.currentUserAnswer) {
      const addObject = {
        id: this.currentQuestionId,
        answer: this.currentUserAnswer,
        comment: this.comentAnswer,
        type: this.currentType,
      };
      const questionIndex = this.userAnswers.questions.findIndex(
        (q: any) => q.id === this.currentQuestionId
      );
      if (questionIndex !== -1)
        this.userAnswers.questions[questionIndex] = addObject;
      else this.userAnswers.questions.push(addObject);
    }

    const checked = this.validateEmpty();
    if (checked) {
      this.currentQuestionIndex++;
      this.mountQuestion();
    } else {
      $("#showError").removeClass("display-none");
      $("#showError").addClass("error-text");
    }
  }

  mountQuestion() {
    //Mounts the page based on the current question and answers
    setTimeout(function () {
      $("#GO_NEXT > button").prop("disabled", true);
      $("#GO_END > button").prop("disabled", true);
    }, 100);
    const self = this;
    if (!this.survey.surQuestionsData) return;
    const questionObj = this.survey.surQuestionsData[this.currentQuestionIndex];
    if (questionObj.type != "") {
      this.currentQuestion = questionObj;
      this.currentQuestionId = questionObj.id;
      this.currentAnswers = this.currentQuestion.answers;
      this.questionLabel = this.currentQuestion.question;
      this.currentType = this.currentQuestion.type;

      this.checkedRadio = -1;
      this.checkedRating = -1;
      this.checkedBoxes = [];
      this.textAreaValue = "";
      this.currentUserAnswer = [];
      this.comentAnswer = "";
      this.checkedIndex = -1;

      const answer = this.userAnswers.questions.find(
        (question: any) => question.id == this.currentQuestionId
      );

      if (answer) {
        const answerIndex = this.currentAnswers.findIndex(
          (asr: any) => asr.id === answer.answer
        );

        switch (answer.type) {
          case "radio":
            this.checkedRadio = answer.answer;
            this.comentAnswer = answer.comment;
            break;
          case "rate":
            this.checkedRating = answer.answer;
            this.comentAnswer = answer.comment;
            this.checkedIndex = answerIndex;
            break;
          case "checkbox":
            this.checkedBoxes = answer.answer;
            this.comentAnswer = answer.comment;
            break;
          case "textarea":
            this.textAreaValue = answer.answer;
            this.comentAnswer = answer.comment;
            break;
        }
      }
    } else {
      this.noMoreQuestions = true;
    }
    setTimeout(function () {
      self.validateAnswer();
    }, 100);
  }

  finishResearch() {
    //Req sending the information
    if (this.currentUserAnswer) {
      const addObject = {
        id: this.currentQuestionId,
        answer: this.currentUserAnswer,
        comment: this.comentAnswer,
        type: this.currentType,
      };
      const questionIndex = this.userAnswers.questions.findIndex(
        (q: any) => q.id === this.currentQuestionId
      );
      if (questionIndex !== -1)
        this.userAnswers.questions[questionIndex] = addObject;
      else this.userAnswers.questions.push(addObject);
    }
    //this.Thankyou();
    this.sendSurveyInfo();
  }

  sair() {
    this.$router.go(-1);
  }

  goBack() {
    if (this.currentQuestionIndex != 0) {
      this.currentQuestionIndex--;
      // this.userAnswers.questions.splice(-1,1);
      this.mountQuestion();
    } else this.$router.go(-1);
  }

  Thankyou() {
    const req = new Request();
    req.visibilityOptions = { success: false, error: false, loading: true };
    req.showSuccessMessage("Obrigado por responder nossa pesquisa!");
    this.$router.push("Surveys");
  }
}
